const appointmentDurations = {
  UNKNOWN: -1,
  FIFTEEN: 15,
  THIRTY: 30,
  FORTY_FIVE: 45,
  SIXTY: 60,
  SEVENTY_FIVE: 75,
  NINETY: 90,
  ONE_TWENTY: 120,
  MULTIPLE: 999,
} as const

export { appointmentDurations }
